import React from 'react';
import SearchHeadingLegacy from './SearchHeadingLegacy';
import SearchHeadingWithAtlassianApps from './SearchHeadingWithAtlassianApps';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Entry point for Search Heading
 * Routes to either legacy or new UI based on experiment flag
 */
const SearchHeading = _ref => {
  let {
    isSearchQueryActive,
    areFiltersActive,
    productName,
    useAtlassianAppsExperimentNewUI = false
  } = _ref;
  return useAtlassianAppsExperimentNewUI ? /*#__PURE__*/_jsx(SearchHeadingWithAtlassianApps, {
    productName: productName
  }) : /*#__PURE__*/_jsx(SearchHeadingLegacy, {
    isSearchQueryActive: isSearchQueryActive,
    areFiltersActive: areFiltersActive,
    productName: productName
  });
};
export default SearchHeading;